import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { Reveal } from "../components/Motion";
import DetailPage, { PageHeader, CtaBand } from "../components/Detail";
import { METHOD_ORDER, pad } from "../lib/site";

export function MethodsOverview() {
  const { t } = useLanguage();
  return (
    <main id="main-content">
      <PageHeader overline={t.methods.pageOverline} title={t.methods.pageTitle} sub={t.methods.pageSub} overlineTestId="methods-page-overline" />
      <div className="mx-auto max-w-6xl px-5 py-14 sm:px-8 sm:py-16">
        <div className="divide-y divide-warmline border-y border-warmline" data-testid="methods-list">
          {METHOD_ORDER.map((slug, i) => {
            const item = t.methods.items[slug];
            return (
              <Reveal key={slug} delay={i * 0.03}>
                <Link
                  to={`/arbeitsweise/${slug}`}
                  data-testid={`method-row-${slug}`}
                  className="group flex flex-col gap-2 py-7 transition-colors sm:flex-row sm:items-center sm:gap-10 sm:px-4 sm:hover:bg-white"
                >
                  <span className="font-mono text-sm font-semibold text-gold-dark" aria-hidden="true">
                    ({pad(i + 1)})
                  </span>
                  <div className="flex-1">
                    <h2 className="font-display text-xl font-semibold tracking-tight text-petrol transition-colors group-hover:text-teal-dark sm:text-2xl">
                      {item.title}
                    </h2>
                    <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-slate2 sm:text-base">{item.teaser}</p>
                  </div>
                  <ArrowUpRight className="hidden h-5 w-5 shrink-0 text-teal-dark transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5 sm:block" aria-hidden="true" />
                </Link>
              </Reveal>
            );
          })}
        </div>
        <div className="mt-14">
          <CtaBand testId="methods-cta-band" ctaTestId="methods-whatsapp-cta" />
        </div>
      </div>
    </main>
  );
}

export function MethodDetail() {
  const { slug } = useParams();
  const { t } = useLanguage();
  const item = t.methods.items[slug];
  if (!item) return <Navigate to="/arbeitsweise" replace />;
  const related = METHOD_ORDER.filter((s) => s !== slug)
    .slice(0, 3)
    .map((s) => ({ slug: s, title: t.methods.items[s].title }));
  return (
    <DetailPage
      data={{ ...item, overline: t.methods.pageOverline }}
      basePath="/arbeitsweise"
      relatedItems={related}
      relatedBasePath="/arbeitsweise"
    />
  );
}
